import React, { useEffect } from "react";
import styled from "styled-components";
import {
  DriverBasicDetailsContainer,
  FieldHolder,
} from "../../../constants/assets/DriverDetailsContainers";
import DriverStoreMappingChangeLog from "../../../constants/DriverStoreMappingChangeLog/DriverStoreMappingChangeLog.json";
import DriverStoreMappingChangeLogList from "../DriverStoreMappingChangeLogList";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import BlankState from "../../Common/BlankState";
import variables from "../../../constants/assets/variables";
import { bindActionCreators } from "redux";
import * as DeliveryDriversActions from "../../../store/actions/DeliveryDrivers";
import { FieldsContainer } from "../../../constants/assets/containers";
import moment from "moment";
import { getDashboardUrl } from "../../../views/Home";

const DriverStoreMappingDetails = ({
  driverStoreMappingDetails,
  getDriverStoreMappingDetails,
}) => {
  const { id } = useParams();

  const handleStoreClick = (storeID) => {
    if (storeID) {
      window.open(getDashboardUrl() + `/admin/users/${storeID}`);
    }
  };

  useEffect(() => {
    if (driverStoreMappingDetails.length === 0) {
      getDriverStoreMappingDetails(id);
    }
  }, []);

  return (
    <DriverStoreMappingDetailsContainer>
      <FieldsContainer>
        <FieldHolder repeat={4} display="grid">
          <span>StoreID</span>
          <span>CreatedAt</span>
          <span>UpdatedAt</span>
          <span>CategoryName</span>
        </FieldHolder>

        {driverStoreMappingDetails.length > 0 ? (
          driverStoreMappingDetails.map((data, index) => {
            return (
              <>
                <FieldHeading repeat={4} display="grid">
                  <span onClick={() => handleStoreClick(data.user_id)}>
                    {data.user_id || "--"}
                  </span>
                  <span>{dateParser(data.created_at) || "--"}</span>
                  <span>{dateParser(data.updated_at) || "--"}</span>
                  <span>{data.category_name || "--"}</span>
                </FieldHeading>
                <DriverStoreMappingChangeLogList
                  changes={data.changes}
                  tableFields={DriverStoreMappingChangeLog}
                />
              </>
            );
          })
        ) : (
          <BlankState message=" " />
        )}
      </FieldsContainer>
    </DriverStoreMappingDetailsContainer>
  );
};

const DriverStoreMappingDetailsContainer = styled(
  DriverBasicDetailsContainer
)``;

const FieldHeading = styled(FieldHolder)`
  span {
    color: ${variables.black};
    word-break: break-all;
  }
`;

function dateParser(rawTime) {
  const parsedDateTime = moment(rawTime).format("YYYY-MM-DD HH:mm:ss");
  return parsedDateTime;
}

function mapDispatchToProps(dispatch) {
  return {
    getDriverStoreMappingDetails: bindActionCreators(
      DeliveryDriversActions.getDriverStoreMappingDetails,
      dispatch
    ),
  };
}

function mapStateToProps(state) {
  const { DeliveryDrivers } = state;
  return {
    driverStoreMappingDetails: DeliveryDrivers.driverStores,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverStoreMappingDetails);
